<template>
  <div
    :class="['doc-sidebar-container']"
  >
    <div class="doc-title plr32">
      <span v-if="title" />
      <slot
        v-else
        name="title"
      />
    </div>
    <t-input
      v-model="searchKeyword"
      clearable
      class="search-input plr32"
      placeholder="搜索名称"
      @change="changeKeyword"
    >
      <template slot="prefixIcon">
        <SearchIcon />
      </template>
    </t-input>
    <div
      class="doc-sidebar-content plr32"
    >
      <Menu
        :nav-list="filteredNavList"
        :default-path="$route.path"
        :opened-depth="openedDepth"
        :expanded-all="expandedAll"
      />
    </div>
  </div>
</template>
<script>
import { SearchIcon } from 'tdesign-icons-vue';
import Menu from './menu/index.vue';

export default {
  name: 'DocSidebar',
  components: {
    SearchIcon,
    Menu,
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    navList: {
      default() {
        return [];
      },
      type: Array
    },
    defaultPath: {
      type: String,
      default: ''
    },
    openedDepth: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      searchKeyword: this.$store.state.doc.keyword,
      mouseOverSidebar: false
    };
  },
  computed: {
    filteredNavList() {
      return this.findNodesByKeyword(this.navList, this.searchKeyword);
    },
    expandedAll() {
      return this.searchKeyword !== '' && !!this.filteredNavList.length;
      // return !!this.filteredNavList.length;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.showCurrentSidebar();
    });
  },
  methods: {
    showCurrentSidebar() {
      const $sidebarContent = $('.doc-sidebar-content');
      const $current = $sidebarContent.find('.menu-item.is-actived');
      // const liHeight = $current.height();
      // const top = $current.length > 0 &&
      // $current.position &&
      // $current.position().top !== undefined  ? $current.position().top : 0;
      // $sidebarContent.scrollTop(top - liHeight);
      $current[0].scrollIntoView();
      document.documentElement.scrollTop = 0;
    },
    findNodesByKeyword(treeData, keyword) {
      if (keyword === '') return treeData;
      const wrapKeyword = (text) =>
        text.replace(new RegExp(`(${keyword})`, 'g'), '<em>$1</em>');

      const filterTree = (node) => {
        const isMatch = node.title.includes(keyword);
        const processedTitle = isMatch && !node.subNavList.length ? wrapKeyword(node.title) : node.title;

        if (isMatch && !node.subNavList.length) {
          return {
            ...node,
            title: processedTitle,
            subNavList: []
          };
        }

        // 处理子节点逻辑
        let children = [];
        children = node.subNavList.map(filterTree).filter(c => c) || [];
        return children.length > 0 ? {
          ...node,
          title: processedTitle,
          subNavList: children
        } : null;
      };

      return treeData.map(filterTree).filter(root => root);
    },
    changeKeyword(value) {
      this.$store.commit('doc/setKeyword', value);
    },
    onMouseOver() {
      this.mouseOverSidebar = true;
    },
    onMouseOut() {
      this.mouseOverSidebar = false;
    }
  }
};
</script>
<style lang="less" scoped>
.plr32 {
  padding: 0 32px;
}
.doc-sidebar-container {
  // width: 208px;
  // margin: 0 auto;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  .doc-title {
    margin-bottom: 12px;
    color: #1D2227;
    font-family: "PingFang SC";
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
  }
  ::v-deep .t-input {
    background-color: #F7F9FD;
    border-color: #F7F9FD;
    margin-bottom: 16px;
    border-radius: 6px;
    &.t-input--focused {
      border-color: #006AFF;
    }
    .t-input__prefix>.t-icon {
      color: #0F182980;
    }
  }
  .doc-sidebar-content {
    // flex: 1;
    height: calc(100% - 86px);
    margin-right: 6px;
    padding-right: 20px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
      // display: none;
    }
    &::-webkit-scrollbar-track {
      background: #fff; /* 滚动条轨道的背景颜色 */
    }
    &::-webkit-scrollbar-thumb {
      background: #E5E9EE; /* 滚动条滑块的颜色 */
      border-radius: 40px; /* 圆角 */
    }

  }
  .search-input {
    width: 100%;
    box-sizing: border-box;
  }
  &.is-hover {
    .doc-sidebar-content {
      &::-webkit-scrollbar {
        display: block;
      }
    }
  }
}
</style>
